'use client'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  deleteNotifications,
  emptyTrash,
  markNotificationsRead,
  purgeNotifications,
  restoreNotifications,
} from '@/services/notifications'
import type {
  NotificationBulkResponse,
  NotificationEmptyTrashResponse,
  NotificationPurgeResponse,
} from '@/services/notifications/types'
import { notificationKeys } from './useNotificationsQuery'

export interface NotificationIdsInput {
  ids: string[]
}

/**
 * Mutations do inbox. Toda ação muda contadores E pelo menos duas listas
 * (origem e destino do status), então invalida a árvore inteira de
 * `notificationKeys.all` — não vale a pena cirurgia de cache aqui.
 */
export function useNotificationActions() {
  const qc = useQueryClient()
  const invalidateAll = () => {
    void qc.invalidateQueries({ queryKey: notificationKeys.all })
  }

  const markRead = useMutation<NotificationBulkResponse, Error, NotificationIdsInput>({
    mutationFn: ({ ids }) => markNotificationsRead(ids),
    onSuccess: invalidateAll,
  })

  const remove = useMutation<NotificationBulkResponse, Error, NotificationIdsInput>({
    mutationFn: ({ ids }) => deleteNotifications(ids),
    onSuccess: invalidateAll,
  })

  const restore = useMutation<NotificationBulkResponse, Error, NotificationIdsInput>({
    mutationFn: ({ ids }) => restoreNotifications(ids),
    onSuccess: invalidateAll,
  })

  const purge = useMutation<NotificationPurgeResponse, Error, NotificationIdsInput>({
    mutationFn: ({ ids }) => purgeNotifications(ids),
    onSuccess: invalidateAll,
  })

  const emptyTrashMutation = useMutation<NotificationEmptyTrashResponse, Error, void>({
    mutationFn: () => emptyTrash(),
    onSuccess: invalidateAll,
  })

  return { markRead, remove, restore, purge, emptyTrash: emptyTrashMutation }
}
